import { LabelHTMLAttributes, Ref } from 'react';
import { cn } from '@/lib/utils';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  ref?: Ref<HTMLLabelElement>;
}

const Label = ({ className, ref, ...props }: LabelProps) => (
  <label
    className={cn('text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70', className)}
    ref={ref}
    {...props}
  />
);

export { Label };
